'use client'

import { useTranslations } from 'next-intl'

import { FansLeaderboardEmptyState } from '@/features/fans-leaderboard'
import { FansBoard } from '@/features/fans-leaderboard/components/FansBoard'
import BackToTop from '@/ui/BackToTop'

import S from './ClubFansLeaderboard.module.scss'

interface ClubFansLeaderboardProps {
  clubId: string
  clubName?: string
}

/** "Fans Leaderboard" tab: the club's current fans. */
const ClubFansLeaderboard = ({
  clubId,
  clubName
}: ClubFansLeaderboardProps) => {
  const t = useTranslations('leaderboardBoard')

  return (
    <div className={S.root}>
      <FansBoard
        clubId={clubId}
        clubName={clubName}
        emptyState={
          <FansLeaderboardEmptyState
            namespace="fansLeaderboard"
            isFiltered={false}
            onClearFilter={() => undefined}
          />
        }
      />
      <BackToTop label={t('backToTop')} />
    </div>
  )
}

export default ClubFansLeaderboard
